import { useEffect, useState } from 'react';
import { Form, Input, message, Modal, Popconfirm, Space, Table, Radio } from 'antd';
import ApiServices from '~services';
import { AutoComplete } from '~components/selection';

export const MenuFunction = ({ dataInput, reload, onLoading }) => {
  const [selected, setSelected] = useState();

  useEffect(() => setSelected(), [dataInput]);

  const onUpdateRow = (e, record) => {
    e?.preventDefault();

    let isUIRender = false;
    let newSystemsCode = '';
    const checkCode = record?.code?.includes('###');

    if (checkCode) {
      const splitCode = record?.code?.split('###');

      record.codeOrigin = splitCode[1];
      isUIRender = true;
      newSystemsCode = record?.arrSystemsCode?.[0];
    }

    record.systemsCode = newSystemsCode;
    record.isUIRender = isUIRender;
    setSelected(record);
  };

  const onDeleteRow = (id) => {
    onLoading(true);
    return ApiServices.deleteMenuFunction(id)
      .then(() => {
        reload?.();
        message.success('Thao tác thành công!!!');
      })
      .catch((err) => {
        console.error('Create Menu', err);
        message.error('Thao tác thất bại');
      })
      .finally(() => onLoading(false));
  };
  const onCreateRow = (e) => {
    e?.preventDefault();
    setSelected({});
  };

  const columns = [
    {
      title: 'Mã',
      dataIndex: 'code',
      render: (val, record) => {
        let newCode = record?.code;
        const checkCode = newCode?.includes('###');

        return (
          <span
            className={!record?.notInGroup ? 'green bold' : ''}
            style={{
              color: checkCode ? 'red' : '',
            }}
          >
            {checkCode ? val?.split('###')[1] : val}
          </span>
        );
      },
    },
    {
      title: 'Tên',
      dataIndex: 'name',
    },
    {
      title: 'Chức năng',
      dataIndex: 'arrSystemsCode',
      render: (val) => val?.join(', '),
    },
    {
      title: '#',
      dataIndex: 'id',
      render: (id, record) => (
        <Space>
          <a href='#' onClick={(e) => onUpdateRow(e, record)}>
            Sửa
          </a>
          <Popconfirm
            className='red pointer'
            title='Xác nhận xóa!'
            onConfirm={() => onDeleteRow(id)}
          >
            Xóa
          </Popconfirm>
        </Space>
      ),
    },
  ];

  if (!dataInput?.arrSysFuncs) {
    return null;
  }

  return (
    <>
      <h3>
        Danh sách Nhóm chức năng ({dataInput?.arrSysFuncs?.length || 0}){' '}
        <a href='#' onClick={onCreateRow}>
          Thêm Mới
        </a>
      </h3>
      <Table dataSource={dataInput?.arrSysFuncs || []} rowKey='id' columns={columns} />
      <FormInput reload={reload} data={selected} menuId={dataInput?.id} />
    </>
  );
};
const FormInput = ({ data, menuId, reload }) => {
  const [isRenderUI, setIsRenderUI] = useState(false);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (data) {
      if (data?.isUIRender) {
        setIsRenderUI(true);
      } else {
        setIsRenderUI(false);
      }
    } else {
      setIsRenderUI(false);
    }
  }, [data]);
  const onChangeRenderUI = (e) => {
    setIsRenderUI(e.target.value);
  };

  const onSubmitForm = (value) => {
    const CODE_UI_RENDER = 'UI_RENDER###';

    // Theem moi
    if (!data?.id) {
      const dataSend = {
        code: isRenderUI ? CODE_UI_RENDER + value?.codeOrigin : value?.code,
        name: value?.name || '',
        arrSystemsCode: isRenderUI ? [value?.systemsCode] : value?.arrSystemsCode,
      };

      return ApiServices.createMenuFunction(menuId, [dataSend])
        .then((res) => {
          if (res?.data === 'success') {
            reload?.();
            onCancelModal();
            message.success('Thao tác thành công!!!');
          } else {
            message.error('Thao tác thất bại');
          }
        })
        .catch((err) => {
          console.error('Create Menu', err);
          message.error('Thao tác thất bại');
        });
    }

    const dataSendUpdate = {
      code: isRenderUI ? CODE_UI_RENDER + value?.codeOrigin : value?.code,
      name: value?.name || '',
      arrSystemsCode: isRenderUI ? [value?.systemsCode] : value?.arrSystemsCode,
    };

    // Cap nhat
    return ApiServices.updateMenuFunction(data.id, dataSendUpdate)
      .then((res) => {
        if (res?.data === 'success') {
          reload?.();
          onCancelModal();
          message.success('Thao tác thành công!!!');
        } else {
          message.error('Thao tác thất bại');
        }
      })
      .catch((err) => {
        console.error('update Menu', err);
        message.error('Thao tác thất bại');
      });
  };

  useEffect(() => {
    data ? setVisible(true) : setVisible(false);
    if (!data?.id) {
      form.resetFields();
    }
    form.setFieldsValue(data);
  }, [data]);

  const onCancelModal = () => setVisible(false);
  const onOkModal = () => form.submit();

  if (!data) {
    return null;
  }

  return (
    <Modal
      title='Thông tin Nhóm chức năng'
      open={visible}
      onCancel={onCancelModal}
      onOk={onOkModal}
    >
      <Form
        form={form}
        layout='vertical'
        name='global_state'
        className='form-job-handle'
        onFinish={onSubmitForm}
      >
        {isRenderUI ? (
          <Form.Item
            name='codeOrigin'
            label='Mã Nhóm Chức Năng'
            rules={[
              {
                required: true,
                message: 'Bạn phải nhập Mã Nhóm',
              },
            ]}
          >
            <Input placeholder='Mã Nhóm' />
          </Form.Item>
        ) : (
          <Form.Item
            name='code'
            label='Mã Nhóm Chức Năng'
            rules={[
              {
                required: true,
                message: 'Bạn phải nhập Mã Nhóm',
              },
            ]}
          >
            <Input placeholder='Mã Nhóm' />
          </Form.Item>
        )}

        {/* <Form.Item
          name='code'
          label='Mã Nhóm Chức Năng'
          rules={[
            {
              required: true,
              message: 'Bạn phải nhập Mã Nhóm',
            },
          ]}
        >
          <Input placeholder='Mã Nhóm' />
        </Form.Item> */}

        <Form.Item
          name='name'
          label='Tên Nhóm Chức Năng'
          rules={[
            {
              required: true,
              message: 'Bạn phải nhập Tên Nhóm',
            },
          ]}
        >
          <Input placeholder='Tên Nhóm' />
        </Form.Item>

        <Radio.Group
          onChange={onChangeRenderUI}
          value={isRenderUI}
          style={{
            marginBottom: '10px',
            marginLeft: '10px',
          }}
          // defaultValue={false}
        >
          <Radio value={false}>Api</Radio>
          <Radio value={true}>Render UI</Radio>
        </Radio.Group>
        {isRenderUI ? (
          <Form.Item
            name='systemsCode'
            label='Chức năng Render UI'
            rules={[
              {
                required: true,
                message: 'Bạn phải nhập Chức năng',
              },
            ]}
          >
            <Input placeholder='Bạn phải nhập Chức năng' />
          </Form.Item>
        ) : (
          <Form.Item
            name='arrSystemsCode'
            label='Chức năng'
            rules={[
              {
                required: true,
                message: 'Bạn phải nhập Chức năng',
              },
            ]}
          >
            <AutoComplete
              asyncApi={ApiServices.getFunctions}
              placeholder='Chọn Chức năng'
              fieldValue='code'
              fieldLabel='code'
              multiple
            />
          </Form.Item>
        )}
        {/* <Form.Item
          name='arrSystemsCode'
          label='Chức năng'
          rules={[
            {
              required: true,
              message: 'Bạn phải nhập Chức năng',
            },
          ]}
        >
          <AutoComplete
            asyncApi={ApiServices.getFunctions}
            placeholder='Chọn Chức năng'
            fieldValue='code'
            fieldLabel='code'
            multiple
          />
        </Form.Item> */}
      </Form>
    </Modal>
  );
};
